const parentElement = document.querySelector('.search-mobil');
const elementToMove = document.querySelector('.search-desk');

if (isMobile.tablet || isMobile.phone) {
    document.documentElement.classList.add('mdev');
    parentElement.append(elementToMove);
}

window.addEventListener('scroll', function () {
    var scrollToTopBtn = document.getElementById('scrollToTopBtn');
    if (window.pageYOffset > 100) {
        scrollToTopBtn.classList.add('show');
    } else {
        scrollToTopBtn.classList.remove('show');
    }
});

document.getElementById('scrollToTopBtn').addEventListener('click', function () {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});

$j(document).ready(function () {

    /** Move Countdown below the Slideshow */

    let announcementMaxWidth = $j(':root').css('--announcementbar_maxwidth');
    let messageCount = $j(':root').css('--message-count');

    if (announcementMaxWidth) {
        let announcementMediaQuery = window.matchMedia(`(max-width: ${announcementMaxWidth})`);

        function handleWindowChange(e) {
            if (e.matches) {
                moveAnnouncementDown();
            }
            else {
                moveAnnouncementUp();
            }
        }

        if (announcementMediaQuery && typeof announcementMediaQuery.addListener === 'function') {
            announcementMediaQuery.addListener(handleWindowChange);
            handleWindowChange(announcementMediaQuery);
        }
    }

    function moveAnnouncementDown() {
        const announcementBar = $j(".announcement-bar .announcement-bar__carousel .prose.cd");
        const announcementBarParent = $j("#announcement-bar-top .announcement-bar .announcement-bar__carousel");
        const mobileAnnouncement = $j("#mobil-announcement .announcement-bar .announcement-bar__carousel");

        if (announcementBar.length) {
            if (mobileAnnouncement.length) {
                announcementBar.appendTo(mobileAnnouncement);
            } else {
                announcementBar.remove();
            }

            const children = announcementBarParent.children();

            if (children.length) {
                const hasSelected = children.filter(".is-selected").length > 0;

                if (!hasSelected) {
                    children.first().addClass("is-selected");
                }
            }
        }
        if (messageCount < 2) {
            $j('#announcement-bar-top carousel-prev-button,#announcement-bar-top carousel-next-button').hide();
        }
    }

    function moveAnnouncementUp() {
        const announcementBar = $j(".announcement-bar .announcement-bar__carousel .prose.cd");
        const announcementBarTop = $j("#announcement-bar-top .announcement-bar .announcement-bar__carousel");

        if (announcementBar.length && announcementBarTop.length) {
            announcementBar.appendTo(announcementBarTop).show();
            $j('#announcement-bar-top carousel-prev-button,#announcement-bar-top carousel-next-button').show();
        }
    }

    /** Announcement-Bar show */

    $j("#announcement-bar-top").show();

    /** Move Accessibility-Button Up if needed */

    const presMo = window.matchMedia("screen and (max-width:699px)");
    let isMobile = false;

    function handleSizeChange(e) {
        if (e === null || e === undefined) {
            return;
        }

        if (e.matches) {
            isMobile = true;
        } else {
            isMobile = false;
        }
    }

    if (presMo !== null && presMo !== undefined) {
        presMo.addListener(handleSizeChange);
        handleSizeChange(presMo);
    }

    const observer = new MutationObserver(function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation === null || mutation === undefined) {
                continue;
            }

            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (mutation.target === null || mutation.target === undefined) {
                    continue;
                }

                if (mutation.target.classList.contains('is-visible')) {
                    handleSizeChange(presMo)
                    if (isMobile) {
                        document.documentElement.style.setProperty('--accessibility-distance', '3.6rem');
                    }
                } else {
                    document.documentElement.style.setProperty('--accessibility-distance', '0rem');
                }
            }
        }
    });
    const target = document.querySelector('.product-sticky-bar');
    if (target !== null && target !== undefined) {
        observer.observe(target, { attributes: true });
    }
});

